












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { SearchActions } from '@/actions/search-actions';
import SmallItemCard from '@/components/item-cards/SmallItemCard.vue';
import ListCardSmallWide from '@/components/list-cards/ListCardSmallWide.vue';
import { GenericItem } from '@/models/items/generic-item-model';
import { ListModel } from '@/models/list-model';

@Component({ components: { SmallItemCard, ListCardSmallWide } })
export default class Search extends Vue {
  results: any[] = [];
  query: string = '';
  waitingForResults = false;

  asItem(item: any) {
    return item as GenericItem;
  }

  asList(list: any) {
    return list as ListModel;
  }

  itemLink(item: any): string {
    return (
      '/list/id/' + this.asItem(item).listId + '#item=' + this.asItem(item.id)
    );
  }

  async submit() {
    this.waitingForResults = true;
    this.results = await SearchActions.doSearch(this.query);
    this.waitingForResults = false;
  }

  created() {
    document.title = 'mixlet: Search';
  }
}
